export default {
  dashboard: "Dashboard",
};
